module.exports = __webpack_public_path__ + "static/media/Git.60fe0007.png";